module.exports = __webpack_public_path__ + "static/media/Luciano_Flores.c68f1205.jpg";